import React, { useCallback } from "react";

import {
    Content,
    ContentBody,
    DialogContainer,
    DialogTop,
    DialogTopLeft,
    DialogTopRight,
    IconHeader,
    TitleHeader,
    RegisterDetailContainer,
    RegisterDetailTag,
    RegisterDetailGoTo,
    ContainerItems
} from "./style";

import { AiOutlineClose } from "react-icons/ai";
import { Register } from "../../interfaces/Register";
import { FormAnswer } from "../../interfaces/FormAnswer";
import { IconList, IconPickerItem } from "react-fa-icon-picker";
import FormAnswerRecord from "../../components/FormAnswerRecord";

interface FormAnswerViewProps {
    open: boolean;
    formAnswer: FormAnswer;
    register: Register;
    onClose: () => void;
}

const FormAnswerView: React.FC<FormAnswerViewProps> = ({ onClose, open, register, formAnswer }) => {

    const goToRegister = useCallback((hash: string, form_answer_id: number) => {
        window.open('/register/' + hash + '/register/' + form_answer_id, '_blank');
    }, []);

    const handleClose = useCallback(async () => {
        onClose();
    }, [onClose]);

    return (
        <>
            <DialogContainer
                fullWidth={true}
                maxWidth="sm"
                open={open}
                style={{ zIndex: 99999 }}
                onClose={handleClose}
            >
                <RegisterDetailContainer>
                    <RegisterDetailTag>
                        Cadastro:
                    </RegisterDetailTag>
                    {register.name}

                    {register.typeUserAccess !== undefined && register.typeUserAccess !== null && register.typeUserAccess !== "V" && (
                        <RegisterDetailGoTo onClick={() => register.hash !== undefined ? goToRegister(register.hash, formAnswer.id_form_answer) : {}}>
                            Ir para o Cadastro
                        </RegisterDetailGoTo>
                    )}
                </RegisterDetailContainer>
                <DialogTop>
                    <DialogTopLeft>
                        <IconHeader color={register?.color !== undefined ? register.color : "gray"}>
                            <div>
                                <IconPickerItem
                                    icon={register.icon as IconList}
                                    color={register?.color}
                                />
                            </div>
                        </IconHeader>
                        <TitleHeader>
                            <h1>
                                {formAnswer !== undefined && formAnswer.title !== undefined ? formAnswer.title : register.name !== undefined ? register.name : "Formulário"}
                            </h1>
                        </TitleHeader>
                    </DialogTopLeft>

                    <DialogTopRight>
                        <button onClick={handleClose}><AiOutlineClose /></button>
                    </DialogTopRight>
                </DialogTop>
                <Content>
                    <ContentBody container>

                        <ContainerItems>
                            <FormAnswerRecord
                                selectedValue={formAnswer}
                                form={formAnswer.form}
                                typeUser={"V"}
                                hideContainer={true}
                                showDetailAnswer={true}
                                register_id={register.id_register}                                
                            />
                        </ContainerItems>

                    </ContentBody>
                </Content>
            </DialogContainer >
        </>
    );

}

export default FormAnswerView;